export class Modal {
    _controller;
    slug;
    id;
    element;
    args;
    triggers_open = {};
    triggers_close = {};
    close_other = true;
    is_open = false;

    constructor(element, args = {}, controller) {
        this.element = element;
        this.args = args;

        this._controller = controller === undefined ? jQuery.fancybox : controller;
    }

    init() {
        const modal = this.element;
        this.id = modal?.id || '';
        this.slug = modal?.dataset?.blockSlug || '';

        this.triggers_open['timer'] = Number(modal.dataset.modalTimer) || 0;
        this.triggers_open['click'] = modal.dataset.modalOpenTrigger ?? false;

        this.triggers_close['timer'] = Number(modal.dataset.modalTimerClose) || 0;
        this.triggers_close['click'] = modal.dataset.modalCloseTrigger ?? false;
        this.triggers_close['sent_timer_close'] = Number(modal.dataset.modalSentTimerClose) || 0;

        if (this.triggers_open['timer']) {
            this.showModalByTimer(this.triggers_open['timer']);
        }

        if (this.triggers_close['timer']) {
            this.hideModalByTimer(this.triggers_close['timer']);
        }

        if (this.triggers_close['sent_timer_close']) {
            const form = modal.querySelector('.wpcf7-form');
            form?.addEventListener(
                'wpcf7mailsent',
                () => this.hideModalByTimer(modal, this.triggers_close['sent_timer_close']),
                false
            );
        }

        if (this.triggers_open['click']) {
            jQuery(document.body).on('click', this.triggers_open['click'], () => this.showModal());
        }

        if (this.triggers_close['click']) {
            jQuery(document.body).on('click', this.triggers_close['click'], () => this.hideModal());
        }

        this.bindModalsEvents();
    }

    showModalByTimer(timer) {
        setTimeout(() => {
            this.showModal();
        }, timer * 1000);
    }

    hideModalByTimer(timer) {
        setTimeout(() => {
            this.hideModal();
        }, timer * 1000);
    }

    showModal(current_args = {}) {
        if (this.close_other) {
            this.hideOtherModals();
        }
        this.open({ src: this.element, ...this.args, ...current_args });
    }

    hideModal() {
        this.close(this.element);
    }

    hideOtherModals() {
        return this.close();
    }

    isOpen() {
        return this.is_open;
    }

    bindModalsEvents() {
        if (this._controller?.defaults?.afterShow) {
            jQuery(document).on('afterShow.fb', (e, instance) => {
                if (instance?.current?.src === this.element) {
                    this.is_open = true;
                }
            });
        } else {
            console.error('afterShow не доступен в контроллере модалок!');
        }

        if (this._controller?.defaults?.afterClose) {
            jQuery(document).on('afterClose.fb', (e, instance) => {
                if (instance?.current?.src === this.element || instance?.group?.[0]?.src === this.element) {
                    this.is_open = false;
                }
            });
        } else {
            console.error('afterClose не доступен в контроллере модалок!');
        }
    }

    open(...args) {
        if (this?._controller) {
            if (this._controller?.open) {
                return this._controller.open(...args);
            } else {
                console.error('Метод Open в контроллере модалок не доступен!');
            }
        }
        jQuery(document.body).trigger('open_modal', [this]);
    }

    close(...args) {
        if (this?._controller) {
            if (this._controller?.close) {
                return this._controller.close(...args);
            } else {
                console.error('Метод Close в контроллере модалок не доступен!');
            }
        }
        jQuery(document.body).trigger('close_modal', [this]);
    }
}
